import { render, staticRenderFns } from "./gaia-imgViewer2.vue?vue&type=template&id=00f99802&scoped=true&"
import script from "./gaia-imgViewer2.vue?vue&type=script&lang=js&"
export * from "./gaia-imgViewer2.vue?vue&type=script&lang=js&"
import style1 from "./gaia-imgViewer2.vue?vue&type=style&index=1&id=00f99802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f99802",
  null
  
)

export default component.exports